<template>
  <div class="flex">
    <div class="w-6/12 pr-8 mb-6">
      <span class="block font-bold text-lg mb-6">CSV</span>
      <span class="block text-gray-700 font-bold"
        >Historial de exportaciones</span
      >
      <ul class="overflow-y-auto" style="max-height: 350px">
        <li v-for="(zip, index) in zips" :key="index" class="p-2 border-b">
          <a :href="filepath(zip.file)" class="text-blue-500 hover:underline">{{
            zip.fecha
          }}</a>
        </li>
      </ul>
    </div>
    <div class="w-6/12">
      <span class="block font-bold text-lg mb-6">SFTP</span>
      <div class="flex flex-col">
        <div class="mb-6">
          <label
            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            for="sftp_user"
          >
            Usuario
          </label>
          <input
            class="appearance-none block w-full bg-gray-200 text-gray-700 border-2 focus:border-blue-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
            id="sftp_user"
            type="text"
            v-model="ftp_user"
          />
        </div>
        <div class="mb-6">
          <label
            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            for="sftp_password"
          >
            Contraseña
          </label>
          <div class="relative flex items-center mb-3">
            <input
              class="appearance-none block w-full bg-gray-200 text-gray-700 border-2 focus:border-blue-500 rounded py-3 pl-4 pr-10 leading-tight focus:outline-none focus:bg-white"
              id="sftp_password"
              :type="passwordVisible ? 'text' : 'password'"
              v-model="ftp_pass"
              autocomplete="off"
            />
            <button
              class="absolute right-0 mr-4"
              @click="passwordVisible = !passwordVisible"
            >
              <i
                class="text-gray-700 fas"
                :class="[passwordVisible ? 'fa-eye-slash' : 'fa-eye']"
              ></i>
            </button>
          </div>
        </div>
        <div class="mb-6">
          <button
            class="w-full py-3 px-4 rounded bg-indigo-600 hover:bg-indigo-400 text-white"
            @click="update"
          >
            Guardar credenciales
          </button>
        </div>
        <div class="mb-6">
          <button
            class="w-full py-3 px-4 bg-blue-400 hover:bg-blue-500 text-white rounded"
            @click="upload"
          >
            Enviar datos por SFTP
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  data() {
    return {
      zips: [],
      ftp_user: "",
      ftp_pass: "",
      passwordVisible: false,
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  methods: {
    ...mapActions(["getData", "checkPassword"]),
    ...mapMutations(["hideModal"]),
    filepath(file) {
      return `${window.location.href}/server/exports/${file}`;
    },
    async update() {
      const check = await this.checkPassword(
        "¿Seguro de actualizar las credenciales de SFTP?"
      );

      if (!check) {
        return;
      }

      axios
        .post("server/index.php", {
          action: "postSFTPLogin",
          user: this.user.num,
          colegio: this.user.colegio,
          ftp_server: btoa("upload.appleschoolcontent.com"),
          ftp_user: btoa(this.ftp_user.replace(/[\u0250-\ue007]/g, "")),
          ftp_pass: btoa(this.ftp_pass.replace(/[\u0250-\ue007]/g, "")),
          timestamp: Date.now(),
        })
        .then(() => {
          Swal.fire({
            icon: "success",
            title: "Credenciales actualizados!",
          }).then(() => this.hideModal);
        });
    },
    async upload() {
      const check = await this.checkPassword(
        "¿Seguro de enviar datos a Apple School Manager?"
      );

      if (!check) {
        return;
      }

      axios
        .post("server/index.php", {
          action: "postUploadSFTP",
          colegio: this.user.colegio,
          ftp_server: btoa("upload.appleschoolcontent.com"),
          ftp_user: btoa(this.ftp_user.replace(/[\u0250-\ue007]/g, "")),
          ftp_pass: btoa(this.ftp_pass.replace(/[\u0250-\ue007]/g, "")),
          timestamp: Date.now(),
        })
        .then((response) => {
          if (response.data.success) {
            Swal.fire({
              icon: "success",
              title: "Exportación enviada!",
            }).then(() => this.hideModal);
          } else if (response.data.error) {
            const title = response.data.error === 'login'
              ? "Login no válido."
              : "Email del dominio no configurado.";
            const text = response.data.error === 'login'
              ? "Usuario y/o contraseña SFTP incorrecto."
              : "Debe asignar un email del dominio en la configuración del centro.";
            Swal.fire({
              icon: "error",
              title,
              text,
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Envio fallido!",
            });
          }
        });
    },
  },
  async created() {
    const [group, zips] = await Promise.all([
      this.getData("getGroup"),
      this.getData("getHistory"),
    ]);

    this.zips = zips.sort((a, b) => b.timestamp - a.timestamp);
    this.ftp_user = atob(group.ftp_user);
    this.ftp_pass = atob(group.ftp_pass);
  },
};
</script>
